import React, { ReactNode } from 'react'
import { Container, Header } from 'semantic-ui-react'

const Page = ({
  header,
  subheader = '',
  children,
  preHeader = null,
}: {
  header: string
  subheader?: string
  children: ReactNode
  preHeader?: ReactNode
}) => (
  <Container text css={{ marginTop: '1rem', marginBottom: '1rem' }}>
    {preHeader}
    <Header as="h1" content={header} subheader={subheader} />
    {children}
  </Container>
)

export default Page
